"use strict";

exports.__esModule = true;
exports["default"] = exports.NavContext = void 0;
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/**
 * Shared context for the navigation bars. We use
 * this to help reduce the need for passing
 * props down multiple levels through both mobile
 * & desktop navs.
 * @package
 */
var NavContext = exports.NavContext = /*#__PURE__*/(0, _react.createContext)({
  routes: [],
  accountRoutes: [],
  accountRoutesProps: {},
  auxillaryRoutes: [],
  offAxisButtonRoute: {},
  premiumRoute: {},
  drawerIsOpen: null,
  toggleDrawer: null,
  userDetails: null,
  elevation: 0,
  height: 150,
  holdingImage: null,
  profilePath: "/",
  ExtraNavComponent: null,
  fontFamilies: {
    selected: "Centra",
    unSelected: "Centra"
  },
  selectedNavbarItemColor: "secondary.0",
  zIndex: 30,
  cartData: {},
  cartShow: true
});

/**
 * A provider for the NavContext. The routes, accountRoutes and
 * auxillaryRoutes props should be passed in from the props of the
 * top-level nav component.
 *
 * @param {object} props Component props
 * @param {array} props.routes The app's main routes.
 * @param {array} props.accountRoutes The app's account routes.
 * @param {object} props.accountRoutesProps Props for the account buttons
 * @param {array} props.auxillaryRoutes The app's auxillary routes.
 * @param {boolean} props.drawerIsOpen Status of drawer.
 * @param {function} props.toggleDrawer Toggle status and a toggle function.
 * @param {object} props.children Children of component.
 * @param {object} props.offAxisButtonRoute Route of button that appears below navbar.
 * @param {object} props.premiumRoute Route for user to signup to premium account.
 * @param {object | null} props.userDetails Logged in user details.
 * @param {object} props.elevation Dropshadow of desktop navbar.
 * @param {object} [props.tabBarColor] Tab bar background colour.
 * @param {object} props.height Height of top section of desktop navbar.
 * @param {object} props.holdingImage Image to display when there is no profile picture available.
 * @param {string} props.profilePath Route for navigating user to their profile page.
 * @param {function | null} [props.ExtraNavComponent] Extra component to be rendered after Auxillary links.
 * @param {object} [props.fontFamilies] Change font family of main route navigation items.
 * @param {number} [props.mobileNavbarHeight] Change height of mobile navbar.
 * @param {number | null} [props.zIndex] Change z-index of whole navbar.
 * @param {object} [props.navbarItemColor] Object defining nav item font color states.
 * @param {string} [props.navbarItemColor.selected] Color of nav item font when active route.
 * @param {string} [props.navbarItemColor.unSelected] Color of nav item font when unactive route.
 * @param {object} [props.tabBarItemColor] Object defining nav item font color states.
 * @param {string} [props.tabBarItemColor.selected] Color of nav item font when active route.
 * @param {string} [props.tabBarItemColor.unSelected] Color of nav item font when unactive route.
 * @package
 */

var NavProvider = function NavProvider(_ref) {
  var routes = _ref.routes,
    accountRoutes = _ref.accountRoutes,
    accountRoutesProps = _ref.accountRoutesProps,
    auxillaryRoutes = _ref.auxillaryRoutes,
    offAxisButtonRoute = _ref.offAxisButtonRoute,
    drawerIsOpen = _ref.drawerIsOpen,
    toggleDrawer = _ref.toggleDrawer,
    children = _ref.children,
    mobileNavbarHeight = _ref.mobileNavbarHeight,
    premiumRoute = _ref.premiumRoute,
    userDetails = _ref.userDetails,
    elevation = _ref.elevation,
    height = _ref.height,
    holdingImage = _ref.holdingImage,
    profilePath = _ref.profilePath,
    ExtraNavComponent = _ref.ExtraNavComponent,
    fontFamilies = _ref.fontFamilies,
    tabBarColor = _ref.tabBarColor,
    tabBarItemColor = _ref.tabBarItemColor,
    zIndex = _ref.zIndex,
    navbarItemColor = _ref.navbarItemColor,
    headerLogo = _ref.headerLogo,
    cartData = _ref.cartData,
    cartShow = _ref.cartShow;
  return /*#__PURE__*/_react["default"].createElement(NavContext.Provider, {
    value: {
      routes: routes,
      tabBarColor: tabBarColor,
      accountRoutes: accountRoutes,
      accountRoutesProps: accountRoutesProps,
      auxillaryRoutes: auxillaryRoutes,
      drawerIsOpen: drawerIsOpen,
      toggleDrawer: toggleDrawer,
      offAxisButtonRoute: offAxisButtonRoute,
      premiumRoute: premiumRoute,
      userDetails: userDetails,
      elevation: elevation,
      height: height,
      mobileNavbarHeight: mobileNavbarHeight,
      holdingImage: holdingImage,
      profilePath: profilePath,
      ExtraNavComponent: ExtraNavComponent,
      fontFamilies: fontFamilies,
      zIndex: zIndex,
      navbarItemColor: navbarItemColor,
      tabBarItemColor: tabBarItemColor,
      headerLogo: headerLogo,
      cartData: cartData,
      cartShow: cartShow
    }
  }, children);
};
var _default = exports["default"] = NavProvider;